
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ImageInput',
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    buttonLabel: {
      type: String,
      default: 'Upload'
    },
    inputWidth: {
      type: String,
      default: 'small'
    },
    inputId: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  }
})
